import React from "react";
import { motion } from "framer-motion";
import type { Variants } from "framer-motion";
import ServiceRequestForm from "../components/ServiceRequestForm";
import { handleCheckout } from "../utils/checkout";
import { useExchangeRate, toKRWLabel } from "../hooks/useExchangeRate";
import { SERVICE_PRICES } from "../constant";

const fadeUp: Variants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: "easeOut" },
    },
};

const PaymentPage: React.FC = () => {
    const { rate } = useExchangeRate();

    return (
        <div className="font-sans bg-white text-[#0A1A3E]">
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={fadeUp}
                className="py-16 bg-white"
            >
                <section id="payment-section" className="py-24 bg-white">
                    <div className="max-w-3xl mx-auto px-4 text-center">
                        <h2 className="text-3xl font-bold text-main mb-4">
                            결제 후 바로 다음 단계로 이어집니다
                        </h2>

                        <p className="text-gray-600 mb-8">
                            결제 완료 후, 아래 폼을 통해
                            <br />
                            분석에 필요한 정보를 제출해주세요.
                        </p>

                        <button
                            onClick={() => handleCheckout("core")}
                            className="bg-accent text-main font-bold px-12 py-5 rounded-xl shadow-lg hover:shadow-xl transition"
                        >
                            £{SERVICE_PRICES.core} 결제하기
                        </button>
                        {rate && (
                          <p className="mt-2 text-sm text-gray-400">
                            {toKRWLabel(SERVICE_PRICES.core * rate)} 상당
                          </p>
                        )}
                    </div>
                </section>

            </motion.section>

            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={fadeUp}
                className="py-16 bg-sub"
            >
                <ServiceRequestForm />
            </motion.section>


        </div>
    );
};

export default PaymentPage;
